// src/sectors/pilates/members/modal/MemberCreateModal/parts/TrainerSelectCard.jsx
import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Icon from '@mui/material/Icon';
import CircularProgress from '@mui/material/CircularProgress';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDSelect from 'components/MDSelect';

import { FieldCard } from '../ui/FieldCard';
import { staffApi } from 'sectors/pilates/staff/api/staffApi';

function staffLabel(s) {
  return (
    s?.fullName ||
    s?.name ||
    s?.displayName ||
    s?.email ||
    (s?.id != null ? `Çalışan #${s.id}` : 'Çalışan')
  );
}

export function TrainerSelectCard({ open, value, onChangeValue }) {
  const [loading, setLoading] = React.useState(false);
  const [items, setItems] = React.useState([]);
  const [err, setErr] = React.useState(null);

  React.useEffect(() => {
    if (!open) return;

    let alive = true;
    setLoading(true);
    setErr(null);

    staffApi
      .list()
      .then((list) => {
        if (!alive) return;
        const activeOnly = (Array.isArray(list) ? list : []).filter((x) => x?.active === true);
        setItems(activeOnly);
      })
      .catch((e) => {
        if (!alive) return;
        setErr(e?.message || 'Çalışan listesi alınamadı.');
        setItems([]);
      })
      .finally(() => {
        if (!alive) return;
        setLoading(false);
      });

    return () => {
      alive = false;
    };
  }, [open]);

  return (
    <FieldCard
      icon="support_agent"
      tone="info"
      title="Eğitmen (Opsiyonel)"
      subtitle="Seçersen, çalışan üyesini daha kolay takip edebilir."
    >
      <MDBox sx={{ display: 'grid', gap: 0.75 }}>
        <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
          Eğitmen
        </MDTypography>

        <MDSelect
          value={value ?? ''}
          onChange={(e) => onChangeValue?.(e.target.value)}
          renderValue={(v) => {
            if (!v) return loading ? 'Yükleniyor…' : 'Eğitmen seçilmedi';
            const found = items.find((x) => String(x.id) === String(v));
            return found ? staffLabel(found) : 'Eğitmen seç';
          }}
          sx={{ width: '100%', '& .MuiOutlinedInput-notchedOutline': { borderRadius: '16px' } }}
        >
          <MenuItem value="">
            <MDTypography variant="button" sx={{ color: 'text.secondary' }}>
              Eğitmen seçilmedi
            </MDTypography>
          </MenuItem>

          {items.map((s) => (
            <MenuItem key={s.id} value={String(s.id)}>
              <MDTypography fontWeight="bold">{staffLabel(s)}</MDTypography>
            </MenuItem>
          ))}
        </MDSelect>

        {loading ? (
          <MDBox display="flex" alignItems="center" gap={1} sx={{ mt: 0.25 }}>
            <CircularProgress size={16} />
            <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
              Çalışanlar yükleniyor…
            </MDTypography>
          </MDBox>
        ) : null}

        {err ? (
          <MDBox display="flex" alignItems="center" gap={0.75} sx={{ mt: 0.25 }}>
            <Icon sx={{ fontSize: 18, color: 'error.main' }}>error_outline</Icon>
            <MDTypography variant="caption" sx={{ color: 'error.main' }}>
              {err}
            </MDTypography>
          </MDBox>
        ) : null}
      </MDBox>
    </FieldCard>
  );
}
